import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';
import { Container, Toolbar } from '@mui/material';

/**
 * Skeleton loader for NavBar.
 * @param {boolean} contentOnly - When true, only the nav links + account area (for use alongside real Logo)
 */
export default function NavBarSkeleton({ contentOnly = false }) {
  const theme = useTheme();

  const toolbarContent = (
    <>
      {!contentOnly && (
        <>
          {/* Desktop Logo Skeleton */}
          <Skeleton
            variant="rectangular"
            width={267.44}
            height={55.1}
            sx={{
              display: { xs: 'none', lg: 'block' },
              mx: '10px',
              borderRadius: '4px',
            }}
          />
          {/* Mobile Hamburger & Logo Skeleton */}
          <Box
            sx={{
              display: { xs: 'flex', lg: 'none' },
              alignItems: 'center',
              gap: 2,
              width: '100%',
            }}
          >
            <Skeleton variant="rectangular" width={44} height={44} sx={{ borderRadius: '4px' }} />
            <Skeleton variant="rectangular" width={200} height={50} sx={{ borderRadius: '4px' }} />
          </Box>
        </>
      )}
      {/* Desktop Navigation Links + Account Skeleton (always shown when contentOnly) */}
      <Box
        sx={{
          display: { xs: 'none', lg: 'flex' },
          alignItems: 'center',
          gap: 3,
          flex: 1,
          justifyContent: 'flex-end',
          mr: 2,
        }}
      >
        {[1, 2, 3, 4, 5].map((item) => (
          <Skeleton
            key={item}
            variant="text"
            width={item === 5 ? 80 : 100}
            height={24}
            sx={{ borderRadius: '4px' }}
          />
        ))}
      </Box>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: '4px' }} />
      </Box>
    </>
  );

  if (contentOnly) {
    return toolbarContent;
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: '#FFFFFF',
        zIndex: { xs: 800, lg: 1500 },
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <Container maxWidth="100%" sx={{ px: { xs: 0, lg: '40px' }, mx: { xs: 0 } }}>
        <Toolbar disableGutters sx={{ minHeight: { xs: '78px', lg: '92px' } }}>
          {toolbarContent}
        </Toolbar>
      </Container>
    </Box>
  );
}
